import api from './api';

class Hotelservice {
  // Get all packages with filters and pagination
  async getHotels(params = {}) {
    try {
      const response = await api.get('/hotels', { params });
      return response.data.data.hotels;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new Hotelservice();